import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: { notification: null, shouldShowNavigationWarning: false },
  reducers: {
    showNotification(state, action) {
      state.notification = {
        status: action.payload.status,
        title: action.payload.title,
        message: action.payload.message,
      };
    },
    setShowNavigationWarning(state, action) {
      state.shouldShowNavigationWarning = action.payload;
    },
  },
});

export const { showNotification, setShowNavigationWarning } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
